<template>
    <div class="item-matter">
        <div class="row-matter">
            <div class="my-cursor" :class="[
                            {'icon-put-away': openChildArray.indexOf(matterItem.info.inventoryId) === -1},
                            {'icon-put-open': openChildArray.indexOf(matterItem.info.inventoryId) > -1}
                        ]"
                 :style="{visibility: matterItem.childArray.length === 0 ? 'hidden':''}"
                 @click.stop="setOpenChildArray(matterItem.info.inventoryId)">
            </div>
            <div class="my-cursor"
                 :class="{
                                'icon-clock': matterItem.timeInfo.state <= 0,
                                'icon-clock-true': matterItem.timeInfo.state === 1,
                                'icon-clock-false': matterItem.timeInfo.state === 2
                             }"
                 :style="{backgroundColor: 'var(--color-priority-' + matterItem.info.priority + ')'}"
                 @click.stop="submitClock(matterItem, {})">
            </div>
            <div class="text-matter my-cursor"
                 :style="{background: matterItem.info.color}"
                 @click.stop="submitMatter(matterItem)"
            >
                {{ matterItem.info.title }}
            </div>
        </div>
        <div class="row-child" v-if="matterItem.childArray.length > 0  && openChildArray.indexOf(matterItem.info.inventoryId) > -1">
            <div class="item-child" v-for="childItem in matterItem.childArray">
                <div class="my-cursor"
                     :class="{
                                        'icon-clock': childItem.timeInfo.state <= 0,
                                        'icon-clock-true': childItem.timeInfo.state === 1,
                                        'icon-clock-false': childItem.timeInfo.state === 2
                                     }"
                     :style="{background: 'var(--color-priority-'+ matterItem.info.priority +')'}"
                     @click.stop="submitClock(matterItem, childItem)">
                </div>
                <div class="text-child-title my-cursor"
                     :style="{background: matterItem.info.color}"
                     @click.stop="submitMatter(matterItem)">
                    {{ childItem.info.title }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";

export default {
name: "MatterItem",

    props: {
        matterItem: {
            type: Object,
            default: {},
        },
    },
    computed: {
        ...mapState("listModules", {
            openChildArray: state => state.openChildArray,
        })
    },
    methods: {
        ...mapMutations('listModules', ["setOpenChildArray"]),
        submitClock: function(matterItem, childItem){
            this.$emit("clockEvent", {matterItem:matterItem, childItem: childItem})
        },
        submitMatter: function(matterItem){
            this.$emit("matterEvent", matterItem)
        },
    },
}
</script>

<style scoped>

div.row-matter{
    width: 100%;
    height: 0.3rem;
    display: flex;
    align-items: center;
    gap: 0.05rem;
}

div.icon-put-away, div.icon-put-open{
    width: 0.14rem;
    height: 0.14rem;
}
div.icon-put-open{
    background: url("../../../assets/images/List/icon-put-open.png");
    background-size: cover;
}
div.icon-put-away{
    background: url("../../../assets/images/List/icon-put-away.png");
    background-size: cover;
}

div.icon-clock, div.icon-clock-true, div.icon-clock-false {
    width: 0.16rem;
    height: 0.16rem;
}

div.icon-clock {
    mask: url("../../../assets/images/List/icon-clock.png") no-repeat;
    mask-size: 100%;
}

div.icon-clock-true {
    mask: url("../../../assets/images/List/icon-clock-true.png") no-repeat;
    mask-size: 100%;
}

div.icon-clock-false {
    mask: url("../../../assets/images/List/icon-clock-false.png") no-repeat;
    mask-size: cover;
}
div.text-matter, div.text-child-title{
    flex: 1;
    height: 0.24rem;
    border-radius: 0.04rem;
    box-sizing: border-box;
    padding: 0 0.08rem;

    font-size: 0.14rem;
    color: #333333;
    line-height: 0.24rem;
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
div.row-child{
    width: 100%;
    box-sizing: border-box;
    padding-left: 0.44rem;
    display: flex;
    flex-direction: column;
    gap: 0.05rem;
}
div.item-child{
    width: 100%;
    display: flex;
    align-items: center;
    gap: 0.05rem;
}
</style>